export const SKELETON_BACK_BUTTON_ID = "skeleton_back_btn_id";
export const GENERIC_ERROR_EVENT = "genericErrorEvent";